import { render, staticRenderFns } from "./SliceTopBarIcon.vue?vue&type=template&id=0526bdf6&"
import script from "./SliceTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./SliceTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports